var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[(_vm.loading)?_c('LoadingIndicator',{staticClass:"primary big"}):_vm._e(),(!_vm.loading)?_c('div',{staticClass:"logo_bg sidebar_logo"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }